import React from 'react';
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Tooltip,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

/**
 * Enhanced ColorPicker Component
 *
 * Provides a color picker with HTML color input and hex text field.
 *
 * @param {Object} props
 * @param {string} props.label - Label for the color picker
 * @param {string} props.color - Current color value (hex format)
 * @param {Function} props.onChange - Callback when color changes
 */
function ColorPicker({ label, color, onChange }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1,
            backgroundColor: color,
            border: '1px solid #ccc',
            flexShrink: 0,
          }}
        />
        <input
          type="color"
          value={color}
          onChange={e => {
            onChange(e.target.value);
          }}
          style={{
            width: 40,
            height: 36,
            border: '1px solid #ccc',
            borderRadius: 4,
            cursor: 'pointer',
          }}
        />
        <TextField
          size="small"
          value={color}
          onChange={e => {
            onChange(e.target.value);
          }}
          sx={{ width: 120 }}
          placeholder="#000000"
          disabled={false}
          readOnly={false}
          InputProps={{
            readOnly: false,
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Enter color in hex format (e.g., #1976d2)">
                  <InfoIcon fontSize="small" color="action" />
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );
}

export default ColorPicker;
